module.exports = __webpack_public_path__ + "img/cat-04.54883abd.png";